import { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { toast } from 'react-toastify'

interface RevenueHeroProps {
    existingRouterId?: string;
    createIntegration: any;
    modalVisible: boolean;
    setModalVisible: any;
}

export default function RevenueHero({ existingRouterId, createIntegration, modalVisible, setModalVisible }: RevenueHeroProps) {
    const [routerId, setRouterId] = useState(existingRouterId || '');

    function validateRouterId(value: string): boolean {
        const trimmedRouterId = value.trim();
        return value === trimmedRouterId && /^\d+$/.test(trimmedRouterId);
    }

    function createRevenueHeroIntegration() {
        const trimmedRouterId = routerId.trim();
        if (!validateRouterId(routerId)) {
            toast.error('Enter the numeric RevenueHero Router ID, not the installation URL.');
            return;
        }

        createIntegration({
            routerId: trimmedRouterId,
            appName: 'revenue-hero'
        });
    }

    return (
        <Dialog open={modalVisible} onOpenChange={setModalVisible}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Connect RevenueHero</DialogTitle>
                    <DialogDescription>
                        Enter your RevenueHero Router ID to connect scheduling.
                    </DialogDescription>
                </DialogHeader>

                <div className="grid gap-4 py-4">
                    <div className="space-y-2">
                        <Input
                            value={routerId}
                            onChange={(e) => setRouterId(e.target.value)}
                            placeholder="123456"
                            className={!validateRouterId(routerId) && routerId ? 'border-red-500' : ''}
                        />
                    </div>
                    <a
                        href="https://help.revenuehero.io"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-blue-600 dark:text-blue-400 underline hover:text-blue-800 dark:hover:text-blue-300 transition-colors"
                    >
                        How to find your RevenueHero Router ID
                    </a>
                </div>

                <DialogFooter>
                    <Button
                        variant="outline"
                        onClick={() => setModalVisible(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={createRevenueHeroIntegration}
                    >
                        Connect
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
